import { createContext } from 'react'
import type { MindMapNode, MindMapEdge, NodeCategory } from '@bandos/shared'

/**
 * Context value for node action callbacks
 * Provides all node manipulation functions to node components
 * This replaces the previous pattern of passing callbacks through node.data
 */
export interface NodeActionsContextValue {
  // Node manipulation
  handleDeleteNode: (id: string) => void
  handleUpdateNodeLabel: (id: string, label: string) => void
  handleCollapseNode: (nodeId: string) => void
  handleExpandNode: (nodeId: string) => void
  handleAddChild: (nodeId: string, nodeCategory: NodeCategory) => void
  /** Creates a blank child node with a specific category. Returns the new node ID. */
  handleDirectChildCreation: (
    parentNodeId: string,
    childCategory: NodeCategory
  ) => string | undefined
  handleAddParent: (
    nodeId: string,
    nodeCategory: NodeCategory,
    triggerElement?: HTMLElement
  ) => void
  handleUpdateNode: (nodeId: string, updates: Partial<MindMapNode>) => void

  // AI operations
  addAIGeneratedNodes: (nodes: MindMapNode[], edges: MindMapEdge[]) => void
  handleGenerateIdeas: (nodeId: string) => Promise<unknown>
  handleGenerateNeedsFromVenture: (nodeId: string) => Promise<unknown>
  handleSynthesizeNeedsFromResearch: (nodeId: string) => Promise<unknown>
  handleGenerateRatings: (nodeId: string, onlyForStakeholderNames?: string[]) => Promise<void>

  // Editor state management
  autoEditNodeId?: string
  clearAutoEdit: () => void
}

export const NodeActionsContext = createContext<NodeActionsContextValue | null>(null)
